import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntro = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Intro",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_951",
				"data-name": "Rectangle 951",
				width: 20,
				height: 18.039,
				transform: "translate(-7311 7284)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Mask_Group_12",
			"data-name": "Mask Group 12",
			transform: "translate(7313 -7281)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_894",
				"data-name": "Group 894",
				transform: "translate(-7311 7284)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_801",
						"data-name": "Path 801",
						d: "M8.318-11.215S6.668-8.233,7-7.741c.186.276,5.732-5.226,6.191-4.846.194.161-4.621,5.033-4.479,5.459a4.239,4.239,0,0,1,3.731,2.314c2.508-.743,6.243-4.748,6.765-3.9.555.9-6.141,5.234-6.141,6.27,0,.42,5.454-3.8,5.463-3.105.007.5-4.749,5.059-5.558,6.533a7.1,7.1,0,0,1-6.5,4.292A6.471,6.471,0,0,1,0-1.192C0-4.766,8.318-11.215,8.318-11.215Z",
						transform: "translate(0.784 12.606)",
						fill: "#eff0f3"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_802",
						"data-name": "Path 802",
						d: "M8.318-11.215S6.668-8.233,7-7.741c.186.276,5.732-5.226,6.191-4.846.194.161-4.621,5.033-4.479,5.459a4.239,4.239,0,0,1,3.731,2.314c2.508-.743,6.243-4.748,6.765-3.9.555.9-6.141,5.234-6.141,6.27,0,.42,5.454-3.8,5.463-3.105.007.5-4.749,5.059-5.558,6.533a7.1,7.1,0,0,1-6.5,4.292A6.471,6.471,0,0,1,0-1.192C0-4.766,8.318-11.215,8.318-11.215Z",
						transform: "translate(0 12.606)",
						fill: "#ffe3bc"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_803",
						"data-name": "Path 803",
						d: "M6.2.754c3.032,0,4.78,2.162,4.78,5.194A5.49,5.49,0,0,1,0,5.949C0,2.917,3.168.754,6.2.754Z",
						transform: "translate(1.176 5.662)",
						fill: "#feb64e"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_804",
						"data-name": "Path 804",
						d: "M4.548.923c2.166,0,3.3,1.394,3.3,3.559A3.922,3.922,0,0,1,0,4.483C0,2.317,2.382.923,4.548.923Z",
						transform: "translate(2.745 7.127)",
						fill: "#fea627"
					})
				]
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_959",
			"data-name": "Rectangle 959",
			width: 24,
			height: 24,
			fill: "rgba(255,255,255,0)"
		})
	]
});
export default SvgIntro;
